export enum ErrorPageType {
  Generic = 'generic',
  UserRevoked = 'user-revoked',
  UserKycRefused = 'user-kyc-refused',
}
